<template>
  <div :class="[address.is_main_address ? 'ecm-address__card is-active' : 'ecm-address__card']">
    <div class="ecm-address__card-left">
      <div class="ecm-address__card-left__top">
        <div class="ecm-address__card-desc-left">
          <p class="ecm-address__card-receiver">{{ address.receiver }}</p>
          <p class="ecm-address__card-phone">{{ address.phone_number }}</p>
        </div>
        <div class="ecm-address__card-desc-right">
          <p class="ecm-address__card-address">
            {{ address.detail_address }}, {{ address.province }}, {{ address.city }}, {{ address.postal_code }}
          </p>
        </div>
      </div>
      <div class="ecm-address__card-left__bottom">
        <div class="ecm-address__card-actions">
          <button class="ecm-address__card-btn btn--update" @click="handleUpdateAddress">Update Address</button>
          <button class="ecm-address__card-btn btn--delete" @click="handleDeleteAddress">Delete</button>
          <button v-if="!address.is_main_address" class="ecm-address__card-btn btn--set-main" @click="handleMainAddress">Set main address</button>
        </div>
      </div>
    </div>
    <div class="ecm-address__card-right">
      <i v-if="address.is_main_address" class="fas fa-check-circle"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card_Address',
  props: {
    address: {
      type: Object,
      default: null
    }
  },
  methods: {
    handleMainAddress () {
      this.$emit('handleMainAddress', { addressId: this.$props.address.id })
    },
    handleUpdateAddress () {
      this.$emit('handleUpdateAddress', this.$props.address)
    },
    handleDeleteAddress () {
      this.$emit('handleDeleteAddress', { addressId: this.$props.address.id })
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm-address__card {
  margin-bottom: 10px;
  border: 1px solid rgba(128, 128, 128, 0.453);
  padding: 15px;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .ecm-address__card-left {
    .ecm-address__card-left__top {
      display: flex;
      justify-content: flex-start;
      .ecm-address__card-desc-left {
        width: 300px;
      }
      .ecm-address__card-desc-right {
        width: 500px;
      }
    }
  }
  .ecm-address__card-right {
    width: 300px;
    text-align: center;
  }
  .ecm-address__card-actions {
    margin-top: 10px;
  }
  .ecm-address__card-btn {
    background: none;
    border: none;
    outline: none;
    padding: 6px 15px;
    border-radius: 3px;
    margin-right: 10px;
    font-weight: 600;
    cursor: pointer;
    &.btn--update {
      color: white;
      background: var(--color-blue-background);
    }
    &.btn--delete {
      color: white;
      background: red;
    }
    &.btn--set-main {
      color: var(--color-blue-background);
      background: yellow;
    }
  }
  &.is-active {
    background: var(--color-blue);
    color: white;
  }
}
</style>
